import { createFeatureSelector } from '@ngrx/store';
import { MembershipState } from './membership.reducer';

export const getMembershipFeatureState =
  createFeatureSelector<MembershipState>('membership');
